var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronUp = function SvgIconChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.121 33.121a3 3 0 0 0 0-4.242L25.394 16.151a3 3 0 0 0-3.668-.446q-.18.106-.348.24a3 3 0 0 0-.227.207L8.422 28.879a3 3 0 0 0 4.243 4.242l10.608-10.606L33.879 33.12a3 3 0 0 0 4.242 0"
  })));
};
export default SvgIconChevronUp;